import { isArray } from 'lodash';

export const getInitials = (string: string, isSingle: boolean) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let initials = '';

  if (string && string.length > 0) {
    let words = string.split(' ');
    let firstWord = '', lastWord = '';

    if (isArray(words)) {
      firstWord = words.shift()?.charAt(0) || '';
      lastWord = words?.pop()?.charAt(0) || '';
    }

    initials =  isSingle || firstWord === lastWord ? firstWord : firstWord + lastWord;
  }
  else {
    initials = chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return initials.toUpperCase();
}
